import React from "react";
import "./styles.css";

function ProgressBar({
  onClick,
  activeIndex,
  style,
  containerTestId = "progress-bar",
  barTestIdPrefix
}) {
  return (
    <div
      className="progress-wrapper"
      style={style}
      data-testid={containerTestId}
    >
      {Array.from({ length: 3 }).map((_, index) => (
        <Bar
          key={index}
          index={index}
          isActive={activeIndex === index}
          onClick={() => onClick(index)}
          testId={`${barTestIdPrefix}-${index}`}
          activeIndex={activeIndex}
        />
      ))}
    </div>
  );
}

export default ProgressBar;

const Bar = ({
  className = "",
  onClick,
  index,
  isActive,
  testId,
  activeIndex
}) => {
  return (
    <div className="meter" onClick={onClick} data-testid={testId}>
      <span style={{ width: "100%" }}>
        <span
          className={
            isActive ? "progress" : index < activeIndex ? "filled" : ""
          }
        ></span>
      </span>
    </div>
  );
};
